import React from 'react';
import axios from 'axios';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('Index', () => {
  test('renders Index component', async () => {
    const promise = Promise.resolve({
      data: [{
             id: 1,
             m_institution_id: 1,
             message_name: "予約時（カレンダー登録時）"}]});

    (axios.get as any).mockResolvedValue(promise);
    render(<Index />);

    await act(() => promise);

    // screen.debug();

    expect(screen.getByText('メッセージ')).toBeInTheDocument();
    expect(screen.getByText('予約時（カレンダー登録時）')).toBeInTheDocument();
  });
});
